import { configureStore } from '@reduxjs/toolkit';
import {
  persistReducer,
  persistStore,
  createTransform,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { rootReducer } from './root.reducer';
import { CommonState, setShowLoader } from './common/common.reducer';

/** Never persist/rehydrate the global overlay — a true value survives refresh and sticks forever. */
const clearShowLoaderTransform = createTransform(
  (inboundState: CommonState) => ({
    ...inboundState,
    showLoader: false,
  }),
  (outboundState: CommonState) => ({
    ...outboundState,
    showLoader: false,
  }),
  { whitelist: ['common'] },
);

const persistedReducer = persistReducer(
  {
    key: 'root',
    version: 1,
    storage,
    transforms: [clearShowLoaderTransform],
  },
  rootReducer,
);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store, null, () => {
  store.dispatch(setShowLoader(false));
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
